import styled from "styled-components"
import {Col} from "react-bootstrap"

import Card from "@irati/ui/src/Layout/Card"
import SvgCard, {SvgCardProps} from "@irati/ui/src/Layout/SvgCard"
import padding from "@irati/ui/src/global/padding"
import {greys} from "@irati/ui/src/global/colors"
import media from "@irati/ui/src/global/media"
import Button from "@irati/ui/src/Button"

export const AddContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${padding.tiny};
  position: relative;
  text-align: center;
  width: 100%;
`

export const StyledCol = styled(Col)`
  display: flex;
  flex-direction: column;
`

export const StyledTile = styled(Card)`
  background: ${greys.white};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-bottom: ${padding.base};
  overflow: hidden;
  padding: ${padding.base};
  ${media.tablet`
    margin-bottom: ${padding.tiny};
    min-height: 100px;
  `}
`

interface StyledTileAddContentProps extends SvgCardProps {
  isMisMidSizedContent: boolean
}

const minMessageHeight = "70px"

// if col-md-6 and smaller than desktop, but bigger than tablet

export const EmptyCard = styled(SvgCard)<StyledTileAddContentProps>`
  display: flex;
  height: calc(100% - ${padding.base});
  min-height: 210px;
  margin-bottom: ${padding.base};
  ${({theme}) => theme.animations.hover}

  ${media.tablet`
    margin-bottom: ${padding.tiny};
  `}
`

export const StyledContentSvgCard = styled(SvgCard)<StyledTileAddContentProps>`
  border-radius: 0px;
  box-shadow: none;
  cursor: initial;
  display: flex;
  height: calc(100% - ${minMessageHeight});
`

export const StyledLink = styled.a``

export const StyledImageTile = styled(StyledTile)`
  padding: 0px;
`

interface StyledImageProps {
  imageUrl: string
}

// 16:9 ratio styling = calc((100vw * 9) / 16)
export const StyledContentWrapper = styled.div`
  padding-top: calc((100% * 9) / 16);
  position: relative;
`

const StyledAspectRatio = styled.div`
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
`

export const StyledImage = styled(StyledAspectRatio)<StyledImageProps>`
  background-image: ${(props) => `url(${props.imageUrl})`};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
`

export const StyledVideo = styled(StyledAspectRatio)``

export const StyledMessage = styled.div`
  background: ${greys.white};
  display: flex;
  flex-direction: column;
  min-height: ${minMessageHeight};
  padding: ${padding.tiny};

  ${media.tablet`
    height: auto;
    min-height: 20px;
  `}

  h1, h2, h3 {
    font-size: 30px;
    line-height: 35px;
    margin-top: 0px;
  }
`

export const StyledContentHover = styled.div`
  background: rgba(255, 255, 255, 0.8);
  height: calc(100% - ${padding.base});
  position: absolute;
  width: calc(100% - ${padding.base});
  z-index: 100;

  &.homepage-edit-tile-overlay-enter {
    opacity: 0;
  }

  &.homepage-edit-tile-overlay-enter-active {
    opacity: 1;
    transition: opacity 200ms;
  }

  &.homepage-edit-tile-overlay-exit {
    opacity: 1;
  }

  &.homepage-edit-tile-overlay-exit-active {
    opacity: 0;
    transition: opacity 200ms;
  }
`

export const ContentButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${padding.tiny};
`

export const EditButtons = styled(Button).attrs({small: true})`
  margin-right: ${({theme}) => theme.spacing.one};
`
